import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import config from 'constants/config'

type OfferTypeItem = App.AppConfig['offerTypesList'][number]

function useLocalizedOfferTypesList(): Array<OfferTypeItem> {
  const intl = useIntl()

  return useMemo(() => {
    const localizedByPathPrefix: Record<string, { title: string; description: string }> = {
      '/hotels': {
        title: intl.formatMessage({
          id: 'JOysw81cGW',
          defaultMessage: 'Hotels',
          description: 'Offer type title for hotels',
        }),
        description: intl.formatMessage({
          id: 'oxJ80BA3Yx',
          defaultMessage: 'The best hotels and resorts in the world',
          description: 'Offer type description for hotels',
        }),
      },
      '/tours': {
        title: intl.formatMessage({
          id: 'm4St3cCpV4',
          defaultMessage: 'Tours',
          description: 'Offer type title for tours',
        }),
        description: intl.formatMessage({
          id: 'qNXIVjLm8Q',
          defaultMessage: 'Tours that do all the hard work for you',
          description: 'Offer type description for tours',
        }),
      },
      '/cruises': {
        title: intl.formatMessage({
          id: 'cjXn1K5I/G',
          defaultMessage: 'Cruises',
          description: 'Offer type title for cruises',
        }),
        description: intl.formatMessage({
          id: 'SMqGumsYbx',
          defaultMessage: 'Thousands of itineraries all around the world',
          description: 'Offer type description for cruises',
        }),
      },
      '/ultra-lux': {
        title: intl.formatMessage({
          id: 'CRC3TL1Aw/',
          defaultMessage: 'Ultra Lux',
          description: 'Offer type title for ultra lux',
        }),
        description: intl.formatMessage({
          id: 'w/CT3tgRsn',
          defaultMessage: 'Experience the world’s most luxurious hotels, tours & cruises',
          description: 'Offer type description for ultra lux',
        }),
      },
      '/search/homes-and-villas': {
        title: intl.formatMessage({
          id: 'n0Lcnj3SFd',
          defaultMessage: 'Homes & Villas',
          description: 'Offer type title for homes and villas',
        }),
        description: intl.formatMessage({
          id: 'qeqmekIva/',
          defaultMessage: 'Entire properties for the ultimate escape',
          description: 'Offer type description for homes and villas',
        }),
      },
      '/experiences': {
        title: intl.formatMessage({
          id: 'ZktURVjTec',
          defaultMessage: 'Experiences',
          description: 'Offer type title for experiences',
        }),
        description: intl.formatMessage({
          id: 'MsIIDzV0ui',
          defaultMessage: 'Immerse yourself in your destination',
          description: 'Offer type description for experiences',
        }),
      },
      '/flights': {
        title: intl.formatMessage({
          id: 'US1wz5RfDG',
          defaultMessage: 'Flights',
          description: 'Offer type title for flights',
        }),
        description: intl.formatMessage({
          id: 'UMR8SIVbcb',
          defaultMessage: 'Your ticket to the world',
          description: 'Offer type description for flights',
        }),
      },
      '/car-hire': {
        title: intl.formatMessage({
          id: 'drUdUUFqLE',
          defaultMessage: 'Car Hire',
          description: 'Offer type title for car hire',
        }),
        description: intl.formatMessage({
          id: 'fsbdoGhF1O',
          defaultMessage: 'Making it easy to get from A to B',
          description: 'Offer type description for car hire',
        }),
      },
    }

    return config.offerTypesList.map((item) => {
      const match = Object.entries(localizedByPathPrefix).find(([prefix]) => item.to.startsWith(prefix))
      if (match) {
        return { ...item, ...match[1] }
      }
      return item
    })
  }, [intl])
}

export default useLocalizedOfferTypesList
